import { render, staticRenderFns } from "./adicionais.vue?vue&type=template&id=7c58f365&scoped=true&"
import script from "./adicionais.vue?vue&type=script&lang=js&"
export * from "./adicionais.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=7c58f365&scoped=true&lang=css&"
import style1 from "./adicionais.vue?vue&type=style&index=1&id=7c58f365&scoped=true&lang=css&"
import style2 from "./adicionais.vue?vue&type=style&index=2&lang=css&"
import style3 from "./adicionais.vue?vue&type=style&index=3&id=7c58f365&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c58f365",
  null
  
)

export default component.exports